/**
 * Created by alvinoktavianus on 6/14/17.
 */

import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

import styles from './MarkAsNonActiveSubscriptionModal.css';

class MarkAsNonActiveSubscriptionModal extends Component {
  render() {
    const { showModal, hideModal, deactiveOutlet } = this.props;
    return (
      <Modal
        show={showModal}
        onHide={hideModal}
        dialogClassName={`${styles.dialog} ${
          styles['mark-outlet-subscription-wrapper']
        } modal-dialog`}
      >
        <Modal.Header closeButton bsClass={styles['modal-header']}>
          <Modal.Title bsClass={styles['modal-title']} componentClass="div">
            Deactivate Outlet?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>Are you sure you want to deactivate this outlet?</div>
          <div>
            <b>
              You will not be charged for this outlet after its expiry date
              because it will not be renewed?
            </b>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="col-md-12">
            <button className="btn btn-default right" onClick={hideModal}>
              No
            </button>
            <button className="btn btn-danger right" onClick={deactiveOutlet}>
              Yes
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default MarkAsNonActiveSubscriptionModal;
